import StudentPanelsConfig from '../../student-container/student-panels.config';

const PointPeopleConfig = {
  title: StudentPanelsConfig.POINT_PEOPLE.human,
  paths: ['student.studentDetails.name.lastFirst', 'student.otherStaff'],
};

export default PointPeopleConfig;
